import { useEffect, useState } from "react";

function Participants() {
  const [submissions, setSubmissions] = useState([]);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchSubmissions = (nextToken = null) => {
    setLoading(true);
    let url = "https://1k129n4bqa.execute-api.ap-south-1.amazonaws.com/prod/participants";
    if (nextToken) {
      url += `?continuationToken=${encodeURIComponent(nextToken)}`;
    }

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        if (nextToken) {
            setSubmissions((prev) => [...prev, ...data.items]); // append
        } else {
            setSubmissions(data.items); // replace on first load
        }
        setToken(data.nextContinuationToken || null);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchSubmissions();
  }, []);

  return (
    <div className="section tricolor-background headerMargin">
      <h4 className="text-xl mb-4 font-bold">Volunteer List</h4>

      {/* Card layout for mobile */}
        <div className="">
        {submissions.map((item, index) => (
            <div key={index} className="border p-4 mb-2 rounded shadow">
            <p className='text-left mb2'><strong>Name:</strong> {item.name} {item.termsAccepted ? "✅" : "❌"}</p>
            <p className='text-left mb2'><strong>Phone:</strong> {item.phone}</p> 
            <p className='text-left mb2'><strong>Location:</strong> {item.city}</p> 
            </div>
        ))}
        </div>

      {token && (
        <button
          className="bg-blue-500 text-white px-4 py-2 mt-4 rounded"
          onClick={() => fetchSubmissions(token)}
          disabled={loading}
        >
          {loading ? "Loading..." : "Load More"}
        </button>
      )}
    </div>
  );
}

export default Participants;
